import { render, staticRenderFns } from "./TopPage.vue?vue&type=template&id=36674406&"
import script from "./TopPage.vue?vue&type=script&lang=js&"
export * from "./TopPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports